//@flow

import React, { useState } from 'react';
import { Form } from '@sharingapples/form';
import { FormGroup } from 'reactstrap';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import queryString from 'query-string';
import differenceInDays from 'date-fns/difference_in_calendar_days';
import addDays from 'date-fns/add_days';
import format from 'date-fns/format';

import {
  GuidePax,
  GuideSearchInput,
  FormSubmitButton,
  GuideBookingDates,
} from './imports';
import { BookingNotAvailableModal } from '../../components/MessageModals';

import { isBookingDateValid } from '../../utils';

import { updateGuideSearchQuery } from '../../redux/actors';

const DATE_FORMAT = 'YYYY-MM-DD';

function SearchFormGroup() {

  return (
    <>
      <FormGroup className="guide-se">
        <GuideSearchInput aria-label="Try ‘Everest Base Camp’" />
      </FormGroup>
      <GuideBookingDates aria-label="Trek start date"/>
      <GuidePax aria-label="Number of Trekkers" />
      <FormGroup>
        <FormSubmitButton buttonText="Search" id="guides-search-btn"/>
      </FormGroup>
    </>
  );
}

const initialValues = {
  pax: 1,
};

function GuideSearchForm(props: RouteComponentProps) {
  const [isMessageModalVisible, setModalVisibility] = useState(null);
  const closeMessage = () => setModalVisibility(false);
  const openMessage = () => setModalVisibility(true);

  const updateQueryState = state => {
    // IF USER HAS LEFT GUIDE INPUT FIELD EMPTY SET ITS VALUE TO EBC.
    if (!state.guideQuery) state.guideQuery = 'Everest Base Camp';
    if(!state.startDate) {
      // IF START DATE IS EMPTY SET ITS VALUES TO A MONTH FROM NOW AND END DATE TO 14 DAYS AFTER START DATE 
      const aMonthFromNow = format(addDays(new Date(), 30), DATE_FORMAT);
      const fifteenDaysFromAMonth = format(addDays(aMonthFromNow, 14), DATE_FORMAT);

      state.startDate = aMonthFromNow;
      state.endDate = fifteenDaysFromAMonth;
    }

    // SHOW MESSAGE IF BOOKING DATE IS INVALID
    if(isBookingDateValid(state.startDate)){
      const { guideQuery:trek , startDate, endDate, pax } = state;
      const  numberOfDays = differenceInDays(endDate, startDate) + 1;
  
      updateGuideSearchQuery({ ...state, numberOfDays });
      return props.history.push(`/list?${queryString.stringify({ trek, startDate, endDate, pax })}`);
    } else {
      return openMessage();
    }
  };

  return (
    <div className="SearchForm">
      <BookingNotAvailableModal isOpen={isMessageModalVisible} close={closeMessage}/>
      <Form
        defaultValue={initialValues}
        onSubmit={updateQueryState}
      >
        <SearchFormGroup />
      </Form>
    </div>
  );
}

export default withRouter(GuideSearchForm);
